
import { applicantStore } from '@/store'
import { ImageUtils } from '@/commons/utils/image'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class MainDetailsAndBiometry extends Vue {
    get personCode (): string {
        return applicantStore.personCode
    }

    get name (): string {
        return applicantStore.applicantFullName
    }

    get fingerprintsTakenDate (): string {
        return applicantStore.fingerprintsCaptured || ''
    }

    get photoUrl (): string | null {
        return ImageUtils.getBiometryImageFromUploadedOrExternalSource(
            applicantStore.applicationBiometry?.photo, applicantStore.biometry?.photo?.data
        )
    }

    get signatureUrl (): string | null {
        return ImageUtils.getBiometryImageFromUploadedOrExternalSource(
            applicantStore.applicationBiometry?.signature, applicantStore.biometry?.signature?.data
        )
    }
}
